import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  bgHomeImages,
} from "../../script";
import "normalize.css/normalize.css";
import CountUp from "react-countup";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Testimonials from "../../components/Testimonials";
import HomeForm from "../../components/HomeForm";
import BhStory from "../../components/BhStory";
import Awards from "../../components/Awards";

import one from "../../assets/img/one.svg";
import two from "../../assets/img/two.svg";
import three from "../../assets/img/three.svg";
import four from "../../assets/img/four.svg";
import beeSafeBlueCircleLogo from "../../assets/img/bee-safe-be-pesticide-free-logo.png";
import bh30logo from "../../assets/img/BH30logo.png";
import "./style.css";
export default function Home() {
  
  const location = useLocation();
  const history = useNavigate(); // Get the history object from React Router
  const form = useRef();

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "Vancouver Landscaping, Lawn Care & Garden Maintenance | BUR-HAN";
    document.title = newTitle;

    const newDescription =
    "Vancouver's #1 landscaping company since 1995. Expert lawn care, hardscaping & garden design in Vancouver, North Van & West Van. 1000+ clients. Free quote: 604-983-2687."

    const descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
  "landscaping Vancouver",
  "landscaping company Vancouver",
  "lawn care Vancouver",
  "garden and lawn maintenance Vancouver",
  "eco-friendly landscaping services",
  "residential and commercial landscaping Vancouver",
  "professional landscapers Vancouver BC",
  "local landscape contractors"
].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);
  

  return (
    <div id="home" className="wrapper">
      <Header />

      {/* ----------------- CAROUSEL SLIDER ----------------- */}
    <div className="slider-wrapper">
  {bgHomeImages.map((item, index) => (
    <div
      key={index}
      className="slider-content bg-fade"
    >
      <img
        src={item.image}
        alt={item.alt}
        className="heroBackground"
        loading={index === 0 ? "eager" : "lazy"}
        fetchPriority={index === 0 ? "high" : "low"}
        decoding="async"
      />

      <div className="inner">
        {index === 0 ? (
          <h1>{item.title}</h1>
        ) : (
          <h2>{item.title}</h2>
        )}
      </div>
    </div>
  ))}

  <img
    className="beeLogo"
    src={beeSafeBlueCircleLogo}
    alt="Bee Safe Be Pesticide Free Blue Circle Logo"
  />

  <img
    className="bh30Logo"
    src={bh30logo}
    alt="BUR-HAN Garden and Lawn Care celebrating 30 years since 1995"
  />
</div>
          
      {/* -------------- END OF CAROUSEL SLIDER -------------*/}

      {/* -----------------  PARTNERS -----------------  */}
     <Awards />
      {/* -------------- END OF PARTNERS -------------*/}
        {/* -------------- TESTIMONIALS --------------   */}
        <Testimonials/>

      {/* -------------- END OF TESTIMONIALS -------------*/}
      {/* -------------- ABOUT -------------- */}
     <BhStory />
      {/* -------------- END OF ABOUT -------------- */}

      {/* -------------- COUNTS -------------- */}
      <section id="counts" className="counts">
        <div className="container" data-aos="fade-up">
          <h2
            className="section-header whiteDash text-white"
            data-aos="zoom-in"
          >
            What we have achieved so far
          </h2>
        </div>
        <div className="row">
          <div
            className="col-3 col-md-3 col-sm-3 d-md-flex align-items-md-stretch"
            data-aos="zoom-in"
          >
            <div className="count-box">
              <i className="bi bi-server"></i>
              <CountUp start={0} end={30} duration={3} enableScrollSpy={true} />
              <p>Years of Service</p>
            </div>
          </div>
          <div
            className="col-3 col-md-3 col-sm-3 d-md-flex align-items-md-stretch"
            data-aos="zoom-in"
          >
            <div className="count-box">
              <i className="bi bi-emoji-smile"></i>
              <CountUp
                start={0}
                end={1030}
                duration={3}
                enableScrollSpy={true}
              />
              <p>Clients </p>
            </div>
          </div>
          <div
            className="col-3 col-md-3 col-sm-3 d-md-flex align-items-md-stretch"
            data-aos="zoom-in"
          >
            <div className="count-box">
              <i className="bi bi-person"></i>
              <CountUp
                start={0}
                end={60}
                suffix="+"
                duration={3}
                enableScrollSpy={true}
              />
              <p>Team Members</p>
            </div>
          </div>
          <div
            className="col-3 col-md-3 col-sm-3 d-md-flex align-items-md-stretch"
            data-aos="zoom-in"
          >
            <div className="count-box">
              <i className="bi bi-reception-4"></i>
              <CountUp
                start={0}
                end={400}
                duration={3}
                enableScrollSpy={true}
              />
              <p>Properties </p>
            </div>
          </div>
        </div>
      </section>
      {/* -------------- END OF COUNTS -------------- */}

      {/* --------------  SERVICES -------------- */}
      <section id="services" className="services section-bg">
        <h2 className="section-header" data-aos="fade-down">
          Our Services
        </h2>
        <p data-aos="zoom-in">
          "We offer excellent services, adapting to a wide range of preferences
          and requirements, ensuring your landscape achieves its utmost
          potential while simultaneously enhancing your property value."
        </p>
        <div className="row">
          <div
            className="col-lg-4 md-3 col-sm-6 col-xs-12"
            data-aos="fade-right"
          >
            <a href="/services/landscape-maintenance">
              <div className="servicesCard">
                <div className="cover item-a">
                  <h3>Landscape Maintenance</h3>
                  <div className="card-back">
                    <ul>
                      <li>Lawn Maintenance</li>
                      <li>Garden Maintenance</li>
                      <li> Water bag installation and filling</li>
                      <li>Irrigation Management</li>
                      <li>Tree staking</li>
                      <li>Pest and Disease Control</li>
                      <li>Tree and Shrub care</li>
                      <li>Seasonal Clean-ups</li>
                      <li>Landscape Enhancement</li>
                    </ul>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-lg-4 md-3 col-sm-6 col-xs-12"
            data-aos="fade-down"
          >
            <a href="/services/hardscape-installs-maintenance">
              <div className="servicesCard">
                <div className="cover item-b">
                  <h3>Hardscape Installs/Maintenance</h3>
                  <div className="card-back">
                    <ul>
                      <li>Paver/slab patios and walkways</li>
                      <li>Modular block walls</li>
                      <li>New Irrigation Installations with New Landscapes</li>
                      <li>Grading and drainage solutions</li>
                      <li>Gravel/river rock installation</li>
                      <li>Excavation</li>
                      <li>Landscape Lighting</li>
                      <li>Water features</li>
                      <li>
                        Paver Maintenance Cleaning/Jointing/Levelling/Repair
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-lg-4 md-3 col-sm-6 col-xs-12"
            data-aos="fade-left"
          >
            <a href="/services/design-and-modelling">
              <div className="servicesCard">
                <div className="cover item-c">
                  <h3>Designs and Modelling</h3>
                  <div className="card-back">
                    <ul>
                      <li>Consultation & Site Analysis </li>
                      <li>2D & 3D Design</li>
                      <li>Plant Selection</li>
                      <li>Hardscaping</li>
                      <li>Landscape Lighting</li>
                      <li>Irrigation</li>
                      <li>Construction Documentation & Project Management</li>
                      <li>Maintenance Plans</li>
                      <li>Permit Assistance</li>
                    </ul>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-lg-4 md-3 col-sm-6 col-xs-12"
            data-aos="fade-right"
          >
            <a href="/services/residential-lawn-care">
              <div className="servicesCard">
                <div className="cover item-l">
                  <h3>Residential Lawn Care</h3>
                  <div className="card-back">
                    <ul>
                      <li>Weekly lawn mowing/edging</li>
                      <li>Fertilizing</li>
                      <li>Liming</li>
                      <li>Aeration</li>
                      <li>Moss Control</li>
                      <li>Organic Weed Control Program</li>
                      <li>Topdressing</li>
                      <li>Overseeding</li>
                      <li>European Chafer Beetle Control </li>
                    </ul>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div className="col-lg-4 md-3 col-sm-6 col-xs-12" data-aos="fade-up">
            <a href="/services/softscape-installs-maintenance">
              <div className="servicesCard">
                <div className="cover item-e">
                  <h3> Softscape Installs/Maintenance</h3>
                  <div className="card-back">
                    <ul>
                      <li> 2D & 3D Design</li>
                      <li>Soil Analysis & Amendment </li>
                      <li> Material installation Mulch/Play-Chip/Rock/Stone</li>
                      <li>
                        Plant Selection & Installation
                        Annuals/Perennials/Trees/Shrubs/Hedges
                      </li>
                      <li>Edging Installations Garden Beds/Paths/Lawns</li>
                      <li> Garden Care and Maintenance</li>
                      <li>Pest and Disease Management</li>
                      <li>
                        Garden Reclamation Cleanups/Overgrown Blackberry+Bamboo
                        Control
                      </li>
                      <li>
                        Restoration Gardens/Native Plant Selection/Bi-law
                        Complaints
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-lg-4 md-3 col-sm-6 col-xs-12"
            data-aos="fade-left"
          >
            <a href="/services/snow-management">
              <div className="servicesCard">
                <div className="cover item-f">
                  <h3>Snow Management</h3>
                  <div className="card-back">
                    <ul>
                      <li>Snow Plowing</li>
                      <li>Snow Shovelling & Snow Blowing</li>
                      <li>Salting, Pre & Post Treatments</li>
                      <li>24/7 Response</li>
                      <li>Seasonal Contracts</li>
                      <li>Snow & Weather Monitoring </li>
                      <li>Insured for Snow Services</li>
                      <li>Warehousing/ Commercial</li>
                      <li>Residential Homes & Strata</li>
                    </ul>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
      {/* -------------- END OF SERVICES -------------- */}

      {/* ----------------- VALUES ----------------- */}
      <section className="ourValues ">
        <h2 className="section-header my-5" data-aos="zoom-in">
          OUR VALUES
        </h2>
        <div className="row">
          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12"
            data-aos="fade-right"
          >
            <div className="content">
              <img src={one} style={{ width: "4.3rem" }} alt="number 1" />
              <h3>Community</h3>
              <p>- We care about nature</p>
              <p>- We care about each other</p>
              <p>- We care about our community</p>
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12"
            data-aos="zoom-in"
          >
            <div className="content ">
              <img src={two} style={{ width: "4.3rem" }} alt="number 2" />
              <h3>Passion</h3>
              <p>- We have fun together</p>
              <p>- We recognize and celebrate our successes</p>
              <p>- We focus on the details and take pride in our work </p>
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12"
            data-aos="fade-left"
          >
            <div className="content">
              <img src={three} style={{ width: "4.3rem" }} alt="number 3" />
              <h3>Progressive</h3>
              <p>- We are collaborative and resourceful</p>
              <p>- We are focused on continuous improvement </p>
              <p>- We are committed to learning and development</p>
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12"
            data-aos-delay="300"
            data-aos="fade-right"
          >
            <div className="content">
              <img src={four} style={{ width: "4.3rem" }} alt="number 4" />
              <h3>Integrity</h3>
              <p>- We are honest in our dealings </p>
              <p>- We are accountable and do what we say</p>
              <p>- We treat others and the environment with respect</p>
            </div>
          </div>
        </div>
      </section>
      {/* -------------- END OF VALUES -------------*/}

      {/* -------------- CONTACT --------------Í */}
     <HomeForm />
      {/* -------------- END OF CONTACT -------------*/}

      {/* FOOTER */}
      <Footer />

    </div>
  );
}
